import { useForm } from "react-hook-form";
import TextInputFormField from "../../components/form-fields/text-input-field/text-input-form-field";
import { UpdatePasswordStyled } from "./update-password.styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { UpdatePasswordFormValidation } from "../../utils/validations";
import { Branding } from "../login/login";
import { v4 as uuid } from "uuid";

import { PrimaryButton } from "../../components/button/button";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { updateAdminPasswordApi, updatePasswordApi } from "../../actions";
import { useDispatch } from "react-redux";
import { addNotification } from "../../store/slices/ui-slice";
import { useState } from "react";

const UpdatePassword = ({ isAdminInvite }: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [isUpdating, setIsUpdating] = useState(false);
  const params = useParams(); // Extracts the token from the URL
  const { token: string } = params;
  const array = string?.replace("%40", "@").split("?email=");

  const token = array?.[0] || "";
  const email = array?.[1] || "";

  const { control, watch, formState } = useForm({
    mode: "all",
    resolver: yupResolver(UpdatePasswordFormValidation()),
  });

  const password = watch().password;
  const handleOnSubmit = async () => {
    try {
      setIsUpdating(true);
      if (isAdminInvite) {
        await updateAdminPasswordApi({
          password: watch().password,
          email: searchParams.get("email"),
          token: searchParams.get("token"),
        });
      } else {
        await updatePasswordApi({
          password: watch().password,
          email: email,
          token: token,
          password_confirmation: password,
        });
      }

      dispatch(
        addNotification({
          id: uuid(),
          type: "success",
          message: "Password has been successfully updated.",
        })
      );

      navigate("/login");
    } catch (error) {
      dispatch(
        addNotification({
          id: uuid(),
          type: "error",
          message: "Unable to update the password. Please try again.",
        })
      );
    } finally {
      setIsUpdating(false);
    }

    console.log("clickeed");
  };
  return (
    <UpdatePasswordStyled>
      <div className="container">
        <div className="title">Reset Your Password</div>
        <div className="flex">
          <TextInputFormField
            name="password"
            label="New Password"
            control={control}
            inputType="password"
            placeholder="Enter here"
          />

          <TextInputFormField
            name="confirm"
            label="Confirm Password"
            control={control}
            inputType="password"
            placeholder="Enter here"
          />
        </div>

        <div className="buttons-container">
          <PrimaryButton
            isLoading={isUpdating}
            disabled={!formState?.isValid}
            onClick={handleOnSubmit}
          >
            Update Password
          </PrimaryButton>
        </div>
      </div>
      <Branding />
    </UpdatePasswordStyled>
  );
};

export default UpdatePassword;
